import ZoneFormConfig from "./form";
import { ZoneFormData } from "@/formTypes/ZoneFormDataType";
import GenericForm from "../GenericForm";
import { ZoneApi, ZoneDataType } from "@/api/ZoneApi";

type ZoneFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl: string
}

const ZoneForm = (props: ZoneFormProps) => {

  return (
    <GenericForm<ZoneFormData, ZoneDataType>
      id={props.id}
      formId={props.formId}
      saveRedirectUrl={props.saveRedirectUrl}
      formConfig={ZoneFormConfig}
      getById={(...arg) => ZoneApi.get(...arg)}
      createFn={(...arg) => ZoneApi.create(...arg)}
      updateFn={(...arg) => ZoneApi.update(...arg)}
      successMessage="La zona ha sido almacenada correctamente"
      errorMessage="No fue posible almacenar la información de la zona"
    />
  )
}

export default ZoneForm;